module.exports = __webpack_public_path__ + "34736292/img/menu-icon.5f8facae.svg";